import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Spinner} from '..';
import {
  CUSTOMERS_DATA_CELLS,
  CUSTOMERS_HEAD_CELLS,
  PAYMENTS_DATA_CELLS,
  PAYMENTS_HEAD_CELLS,
} from '../../constants/customersCells';
import {useTableSort} from '../../utils/sortUtilities';
import Table from '../Table';

const CustomersTab = ({
  customers,
  loading,
  hideAddBtn,
  pendingPayments = false,
}) => {
  const navigate = useNavigate();
  const onRowClick = id => {
    navigate(`/customers/${id}`);
  };
  const rowHref = id => `/customers/${id}`;
  const onAdd = () => {
    navigate('/customers/new');
  };
  const tableOrder = useTableSort('asc', 'createdAt');

  const DATA_CELLS = pendingPayments
    ? PAYMENTS_DATA_CELLS
    : CUSTOMERS_DATA_CELLS;
  const HEAD_CELLS = pendingPayments
    ? PAYMENTS_HEAD_CELLS
    : CUSTOMERS_HEAD_CELLS;

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={customers}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
      onRowClick={onRowClick}
      rowHref={rowHref}
      onAdd={!hideAddBtn && onAdd}
      noToolbar={hideAddBtn}
      {...tableOrder}
    />
  );
};

export default CustomersTab;
